import React, { useEffect, useState } from "react";
import PlainEditor from "../editor/plainEditor.js";
export default function SimpleMessage(props) {
    const { content } = props;
    const [u, setU] = useState(0);
    useEffect(() => {
        setU((o) => o + 1);
    }, [content.messageContent]);
    useEffect(() => {
        props.onUpdate({ type: "not-relevant" });
    }, []);
    return (React.createElement("div", null,
        React.createElement(PlainEditor, { editable: false, example: content.messageContent, onChange: () => { }, label: "", update: u })));
}
